import React from "react";
import { useQuery } from "@tanstack/react-query";
import { GetOneUser } from "../Api/Api";
import { useAppSelector } from "../Global/Store";
import styled from "styled-components";

const DashHistoryDetail = () => {
  const userOne = useAppSelector((state) => state?.currentUser);

  const { data } = useQuery({
    queryKey: ["post"],
    queryFn: () => GetOneUser(userOne?._id),
  });

  const getOneHistory = (_id: string | undefined) => {
    return data?.data?.history?.filter((value: any) => value._id === _id);
  };
  const getTractionId = useAppSelector(
    (state) => state?.storeUserTransactionId
  );

  const [storeData] = React.useState(getOneHistory(getTractionId!));

//   console.log("data", getTractionId);

  return (
    <Container>
      {storeData.map((data: any) => (
        <Card key={data._id}>
          <Wrap>
            <Key>date</Key> : <Value>{data.date}</Value>
          </Wrap>
          <Wrap>
            <Key>amount</Key> : <Value>{data.amount}</Value>
          </Wrap>
          <Wrap>
            <Key>transactionRefrence</Key> :{" "}
            <Value>{data.transactionRefrence}</Value>
          </Wrap>
          <Wrap>
            <Key>transactionType</Key> : <Value>{data.transactionType}</Value>
          </Wrap>
          <Wrap>
            <Key>time</Key> : <Value>{data.time}</Value>
          </Wrap>
        </Card>
      ))}
    </Container>
  );
};

export default DashHistoryDetail;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const Card = styled.div`
  width: 300px;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  background-color: lavender;
  flex-direction: column;
`;

const Wrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Key = styled.div`
  font-weight: 600;
  color: #8b28e1;
`;
const Value = styled.div`
  font-weight: 500;
  color: red;
  margin-left: 10px;
`;
